import type { AgentImage } from '../agent/agentClient';

/**
 * 浏览器端把图片压到适合聊天的大小再发。
 * 不把原图直接 base64 塞进请求：手机照片动辄 10MB，服务端和模型都吃不消。
 */
export async function fileToChatImage(file: File): Promise<AgentImage> {
  if (!/^image\/(png|jpeg|webp|gif)$/i.test(file.type)) {
    throw new Error('只支持 PNG / JPEG / WebP / GIF 图片');
  }
  if (file.size > 12 * 1024 * 1024) {
    throw new Error('图片太大（最大 12MB）');
  }
  const objectUrl = URL.createObjectURL(file);
  try {
    const image = await new Promise<HTMLImageElement>((resolve, reject) => {
      const el = new Image();
      el.onload = () => resolve(el);
      el.onerror = () => reject(new Error('图片读取失败'));
      el.src = objectUrl;
    });
    const maxEdge = 1600;
    const scale = Math.min(1, maxEdge / Math.max(image.width, image.height));
    const width = Math.max(1, Math.round(image.width * scale));
    const height = Math.max(1, Math.round(image.height * scale));
    const canvas = document.createElement('canvas');
    canvas.width = width;
    canvas.height = height;
    const ctx = canvas.getContext('2d');
    if (!ctx) throw new Error('浏览器不支持图片处理');
    ctx.fillStyle = '#ffffff';
    ctx.fillRect(0, 0, width, height);
    ctx.drawImage(image, 0, 0, width, height);
    const dataUrl = canvas.toDataURL('image/jpeg', 0.82);
    return {
      dataUrl,
      mimeType: 'image/jpeg',
      name: file.name.slice(0, 120),
    };
  } finally {
    URL.revokeObjectURL(objectUrl);
  }
}
